import { load } from 'recaptcha-v3'
import { ReCaptchaInstance } from 'recaptcha-v3/dist/ReCaptchaInstance'
import { RECAPTCHA_V3_PUBLIC_SITE_KEY } from '../environment'
import RecaptchaRequiredError from '../errors/RecaptchaRequiredError'
import { RecaptchaPayload } from './slice'

let recaptcha: ReCaptchaInstance | null

export async function loadRecaptcha(onLoaded?: (recaptcha: ReCaptchaInstance) => void) {
  recaptcha = await load(RECAPTCHA_V3_PUBLIC_SITE_KEY)
  if (onLoaded) {
    onLoaded(recaptcha)
  }
}

export async function executeRecaptcha(action ?: string) {
  if (recaptcha) return await recaptcha.execute(action)
  throw new RecaptchaRequiredError('Recaptcha Loading Failed')
}

export async function generateRecaptchaToken<T extends RecaptchaPayload>(payload?: T) {
  const isV3Captcha = !payload?.recaptchaV2Code
  let recaptchaToken: string | undefined
  if (isV3Captcha) {
    recaptchaToken = await executeRecaptcha()
  } else {
    recaptchaToken = payload.recaptchaV2Code
  }
  if (recaptchaToken) return recaptchaToken
  throw new RecaptchaRequiredError('', 'Recaptcha Token Error')
}